import MyTable from "components/UIElements/MyTable";
import { useParams ,useLocation } from "react-router-dom";
import { useContext } from 'react';
import { AuthContext } from 'shared/context/auth-context'
import EndPoints from 'shared/endPoints/EndPoints.json';



export default function HistoryOBD() {
    const { id } = useParams();
    const endPoint = `${EndPoints.CONTRACT.GETOBDHISTORY}/?id=${id}`
    const location = useLocation();
    const exportFilename = `Anytime_BTM_OBD_History_Contract_${location.state.policyNumber}`;
    const { roleUser } = useContext(AuthContext)
    const allRoles = ['AnyTimeAdmin', 'AnyTime', 'GT']

    const columns = [
        {
            title: 'IMEI Συσκευής',
            dataIndex: 'deviceImei',
            key: 'deviceImei',
            showOnRoles: allRoles,
        },
        {
            title: 'IMSI',
            dataIndex: 'simImsi',
            key: 'simImsi',
            showOnRoles: allRoles,
        },
        {
            title: 'Ημερομηνία Καταχώρησης',
            dataIndex: 'dateCreated',
            key: 'dateCreated',
            showOnRoles: ['AnyTime', 'GT'],
        },
        {
            title: 'Κατάσταση',
            dataIndex: 'action',
            key: 'action',
            showOnRoles: allRoles,
        },

    ].filter(item => item.showOnRoles.indexOf(roleUser) !== -1);

    return <MyTable columns={columns} endPoint={endPoint} exportFilename={exportFilename} ContractTab/>
}